<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/apBgTs/tc-custom/9781467465069.jpg?1734751853461" alt="This image is the cover for the book The Apostle and the Empire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Apostle and the Empire
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Was Paul silent on the injustices of the Roman Empire? Or have his letters just been misread?</b><br/><br/>The inclusion of anti-imperial rhetoric in Paul’s writings has come under scrutiny in recent years. Pressing questions about just how much Paul critiques Rome in his letters and how publicly critical he could have afforded to be have led to high-profile debates—most notably between N. T. Wright and John M. G. Barclay.<br/><br/>Having entered the conversation in 2015 with his book <i>Hidden Criticism?</i>, Christoph Heilig contributes further insight and new research in <i>The Apostle and the Empire</i>, reevaluating the case for Paul hiding his criticism of Rome in the subtext of his letters. Heilig argues that scholars have previously overlooked passages that openly denounce the empire—for instance, the “triumphal procession” in 2 Corinthians, which Heilig discusses in detail by drawing on a variety of archaeological data.<br/><br/>Furthermore, Heilig takes on larger issues of theory and methodology in biblical studies, raising significant questions about how interpreters can move beyond outdated methods of reading the New Testament toward more robust understandings of the ways ancient texts convey meaning. His groundbreaking work is a must-read for Pauline scholars and for anyone interested in how one of Christianity’s most important teachers communicated his unease with the global superpower of his day.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christoph Heilig, John M. G. Barclay
      </h2>
      
      <p class="authorDescription body article"><B>Christoph Heilig</B> leads a research group at the University of Munich that focuses on the intersection between literary studies and biblical exegesis. His books include <I>The Apostle and the Empire</I> (2022), <I>Paul&rsquo;s Triumph</I> (2017), and <I>Hidden Criticism</I> (2015). His previous book on narratives in Paul (<I>Paulus als Erz&auml;hler</I>, 2020) received a Manfred Lautenschlaeger Award for Theological Promise.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?020e6aa2